{
  "accept-invite-form-button": "Create Account",
  "accept-invite-form-heading": "Welcome to Elements!",
  "accept-invite-form-subheading": "Let’s get started by creating your account.",

  "accept-invite-email-in-use-heading": "Please use a different email address.",
  "accept-invite-email-in-use-description": "No two accounts may have the same email address, and the one you entered is already associated with another account.\n\nIf you’re trying to connect to a new advisor, please try using a different email address.",

  "invitation-acceptance-success-heading": "You’re in!",
  "invitation-acceptance-success-button": "Open Elements",
  "invitation-acceptance-success-app-download-prompt": "Don’t have Elements installed yet?",
  "invitation-acceptance-success-mobile-subheading": "Your account has been created and you’re now connected to {{- firmName}}.",
  "invitation-acceptance-success-desktop-subheading": "Your account has been created and you’re now connected to {{- firmName}}.\n\nNow head over to your phone and install the Elements app if you haven’t already. You’ll use your email and password to sign in."
}
